<template>
  <div id="client-modal" class="modal"  v-show="modalShown">
    <div class="modal-main">
      <div class="title-area">
        <h2>顧客担当者設定</h2>
      </div>
      <!-- ローディングモーダル -->
      <dd-loading-modal ref="loadingModalRef" />
      <div class="data-area">
        <ul>
          <li>
            <span class="label">顧客コード<span class="required">【必須】</span></span>
            <input type="text" v-if="editClientData" v-model="editClientData.ccorpClientCd">
            <input type="text" v-else v-model="corpClientCd" placeholder="顧客コード">
            <div class="validate_error_messages">{{ validateErrorMessages.corpClientCd }}</div>
          </li>
          <li>
            <span class="label">顧客会社名</span>
            <input type="text" v-if="editClientData" v-model="editClientData.ccorpClientName">
            <input type="text" v-else v-model="corpClientName" placeholder="顧客会社名">
            <div class="validate_error_messages">{{ validateErrorMessages.corpClientName }}</div>
          </li>
          <li>
            <span class="label">顧客支店名</span>
            <input type="text" v-if="editClientData" v-model="editClientData.ccorpClientBranchName">
            <input type="text" v-else v-model="corpClientBranchName" placeholder="顧客支店名">
            <div class="validate_error_messages">{{ validateErrorMessages.corpClientBranchName }}</div>
          </li>
          <li>
            <span class="label">顧客部署名</span>
            <input type="text" v-if="editClientData" v-model="editClientData.ccorpClientDepartmentName">
            <input type="text" v-else v-model="corpClientDepartmentName" placeholder="顧客部署名">
            <div class="validate_error_messages">{{ validateErrorMessages.corpClientDepartmentName }}</div>
          </li>
          <li>
            <span class="label">顧客郵便番号</span>
            <input type="text" v-if="editClientData" v-model="editClientData.ccorpClientPostcd">
            <input type="text" v-else v-model="corpClientPostcd" placeholder="顧客郵便番号">
            <div class="validate_error_messages">{{ validateErrorMessages.corpClientPostcd }}</div>
          </li>
          <li>
            <span class="label">顧客住所</span>
            <input type="text" v-if="editClientData" v-model="editClientData.ccorpClientAddress">
            <input type="text" v-else v-model="corpClientAddress" placeholder="顧客住所">
            <div class="validate_error_messages">{{ validateErrorMessages.corpClientAddress }}</div>
          </li>
          <li>
            <span class="label">顧客電話番号</span>
            <input type="text" v-if="editClientData" v-model="editClientData.ccorpClientTel">
            <input type="text" v-else v-model="corpClientTel" placeholder="顧客電話番号">
            <div class="validate_error_messages">{{ validateErrorMessages.corpClientTel }}</div>
          </li>
          <li>
            <span class="label">顧客FAX番号</span>
            <input type="text" v-if="editClientData" v-model="editClientData.ccorpClientFax">
            <input type="text" v-else v-model="corpClientFax" placeholder="顧客FAX番号">
            <div class="validate_error_messages">{{ validateErrorMessages.corpClientFax }}</div>
          </li>
          <li>
            <span class="label">顧客メールアドレス</span>
           <input type="text" v-if="editClientData" v-model="editClientData.ccorpClientMail">
            <input type="text" v-else v-model="corpClientMail" placeholder="顧客メールアドレス">
            <div class="validate_error_messages">{{ validateErrorMessages.corpClientMail }}</div>
          </li>
          <li>
            <span class="label">顧客URL</span>
           <input type="text" v-if="editClientData" v-model="editClientData.ccorpClientUrl">
            <input type="text" v-else v-model="corpClientUrl" placeholder="顧客URL">
            <div class="validate_error_messages">{{ validateErrorMessages.corpClientUrl }}</div>
          </li>
          <li>
            <span class="label">顧客担当者コード<span class="required">【必須】</span></span>
            <input type="text" v-if="editClientData" v-model="editClientData.ccorpClientPersonCd">
            <input type="text" v-else v-model="corpClientPersonCd" placeholder="顧客担当者コード">
            <div class="validate_error_messages">{{ validateErrorMessages.corpClientPersonCd }}</div>
          <li>
            <span class="label">顧客担当者名<span class="required">【必須】</span></span>
            <input type="text" v-if="editClientData" v-model="editClientData.ccorpClientPersonName">
            <input type="text" v-else v-model="corpClientPersonName" placeholder="顧客担当者名">
            <div class="validate_error_messages">{{ validateErrorMessages.corpClientPersonName }}</div>
           <li>
            <span class="label">顧客担当者電話番号</span>
            <input type="text" v-if="editClientData" v-model="editClientData.ccorpClientPersonTel">
            <input type="text" v-else v-model="corpClientPersonTel" placeholder="顧客担当者電話番号">
            <div class="validate_error_messages">{{ validateErrorMessages.corpClientPersonTel }}</div>
          </li>
           <li>
            <span class="label">顧客担当者メールアドレス</span>
            <input type="text" v-if="editClientData" v-model="editClientData.ccorpClientPersonMail">
            <input type="text" v-else v-model="corpClientPersonMail" placeholder="顧客担当者メールアドレス">
            <div class="validate_error_messages">{{ validateErrorMessages.corpClientPersonMail }}</div>
          </li>
        </ul>
      </div>
      <div class="button-area">
      <button type="button" class="main_btn" v-if="editClientData" @click="updateClientData">設定</button>
      <button type="button" class="main_btn" v-else @click="updateClientData">登録</button>
      <button type="button" class="main_btn" v-if="editClientData" @click="confirmDelete">削除</button>
      <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../../../utils/Api'
import * as AppUtil from '../../../utils/App'
import {API_URL} from '../../../constants/App'
import LoadingModal from '../../common/LoadingModal'

export default {
  name: 'ClientModal',
  components: {
    'dd-loading-modal': LoadingModal
  },
  props: {
    clientPersonList: Array,
    userAccountList: Array
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      /** 担当者情報 */
      corpClientCd: null,
      corpClientName: null,
      corpClientBranchName: null,
      corpClientDepartmentName: null,
      corpClientPostcd: null,
      corpClientAddress: null,
      corpClientTel: null,
      corpClientFax: null,
      corpClientMail: null,
      corpClientUrl: null,
      corpClientPersonCd: null,
      corpClientPersonName: null,
      corpClientPersonTel: null,
      corpClientPersonMail: null,

      /** 編集中データ */
      editClientData: null,
      validateErrorMessages: {}
    }
  },
  methods: {
    /** 新規モーダル */
    showNewModal: function () {
      this.clearData()
      this.modalShown = true
    },
    /** 編集モーダル */
    showEditModal: function (data) {
      this.editClientData = Object.assign({}, data)
      this.modalShown = true
    },
    /** キャンセル */
    onCancel: function () {
      this.clearData()
      this.modalShown = false
    },
    /** 物件情報更新 */
    updateClientData: function () {
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        clientId: this.editClientData ? this.editClientData.ccorpClientPersonId : null,
        corpClientCd: this.editClientData ? this.editClientData.ccorpClientCd : this.corpClientCd,
        corpClientName: this.editClientData ? this.editClientData.ccorpClientName : this.corpClientName,
        corpClientBranchName: this.editClientData ? this.editClientData.ccorpClientBranchName : this.corpClientBranchName,
        corpClientDepartmentName: this.editClientData ? this.editClientData.ccorpClientDepartmentName : this.corpClientDepartmentName,
        corpClientPostcd: this.editClientData ? this.editClientData.ccorpClientPostcd : this.corpClientPostcd,
        corpClientAddress: this.editClientData ? this.editClientData.ccorpClientAddress : this.corpClientAddress,
        corpClientTel: this.editClientData ? this.editClientData.ccorpClientTel : this.corpClientTel,
        corpClientFax: this.editClientData ? this.editClientData.ccorpClientFax : this.corpClientFax,
        corpClientMail: this.editClientData ? this.editClientData.ccorpClientMail : this.corpClientMail,
        corpClientUrl: this.editClientData ? this.editClientData.ccorpClientUrl : this.corpClientUrl,
        corpClientPersonCd: this.editClientData ? this.editClientData.ccorpClientPersonCd : this.corpClientPersonCd,
        corpClientPersonName: this.editClientData ? this.editClientData.ccorpClientPersonName : this.corpClientPersonName,
        corpClientPersonTel: this.editClientData ? this.editClientData.ccorpClientPersonTel : this.corpClientPersonTel,
        corpClientPersonMail: this.editClientData ? this.editClientData.ccorpClientPersonMail : this.corpClientPersonMail
      }
      if (!this.editClientData) {
        axios.post(API_URL.PROPERTY + '/client/add', payload
        ).then(response => {
          this.$refs.loadingModalRef.showModal(false)
          let modalData = {
            messages: ['登録しました'],
            onOk: () => {
              this.modalShown = false
              this.$emit('getClientList')
            }
          }
          this.validateErrorMessages = {}
          AppUtil.showModal(modalData)
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
      } else {
        axios.post(API_URL.PROPERTY + '/client/update', payload
        ).then(response => {
          this.$refs.loadingModalRef.showModal(false)
          let modalData = {
            messages: ['変更しました'],
            onOk: () => {
              this.modalShown = false
              this.$emit('getClientList')
            }
          }
          this.validateErrorMessages = {}
          AppUtil.showModal(modalData)
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
      }
    },
    /** 削除確認 */
    confirmDelete: function () {
      let modalData = {
        messages: ['本当に削除しますか？'],
        modalType: 'confirm',
        textAlign: 'left',
        onOk: this.deleteSubmit
      }
      AppUtil.showModal(modalData)
    },
    /** 物件情報削除 */
    deleteSubmit: function () {
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        targetId: this.editClientData.ccorpClientPersonId
      }
      axios.post(API_URL.PROPERTY + '/client/delete', payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          this.showModal = false
          let modalData = {
            messages: ['削除しました。'],
            onOk: () => {
              this.modalShown = false
              this.$emit('getClientList')
            }
          }
          AppUtil.showModal(modalData)
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
    },
    clearData: function () {
      this.corpClientCd = null
      this.corpClientName = null
      this.corpClientBranchName = null
      this.corpClientDepartmentName = null
      this.corpClientPostcd = null
      this.corpClientAddress = null
      this.corpClientTel = null
      this.corpClientFax = null
      this.corpClientMail = null
      this.corpClientUrl = null
      this.corpClientPersonCd = null
      this.corpClientPersonName = null
      this.corpClientPersonTel = null
      this.corpClientPersonMail = null
      this.editClientData = null
      this.validateErrorMessages = {}
    }
  }
}
</script>
<style lang="scss" scoped>
li{
  margin-bottom: 20px;
  div{
    width: 175px;
    display: inline-block;
    padding: 10px;
    text-align: left;
  }
  .label{
    min-width: 190px;
    display: inline-block;
    text-align: left;
    font-weight: bold;
  }
   input{
    min-width: 260px;
  }
}
.data-area {
  max-height: 620px;
  padding: 20px;
  overflow: auto;
}
.modal-main{
  max-height: 85%;
  min-width: 650px;
}
.count_limit{
  font-size: 8px;
}
.required{
  color: #ff0000;
}
.validate_error_messages {
  color: #dc3545;
  text-align: left;
  min-width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/list/modal/ClientModal.vue